import React, { useState, useEffect } from 'react';
import { get, post } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import { ViewIcon } from '../vm/components/icons';
import { Link } from 'react-router-dom';
import { GrDocumentZip, GrDocumentExcel } from 'react-icons/gr';
import Breadcrumb from '../../components/Breadcrumb';

const Coupons = () => {
  const formFields = {
    companyId: '',
    couponValue: '',
    totalCoupons: '',
    validFrom: '',
    validTill: '',
    excel: true,
    qrCodes: true,
    pdfFiles: true,
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [couponForm, setCouponForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [couponList, setCouponList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const handleShow = () => {
    setShowConfirmModel(true);
    setCouponForm(formFields);
  };

  const handleChange = (event) => {
    if (event.target.type !== 'checkbox') event.preventDefault();
    let name = event.target.name;
    let value = event?.target?.value;
    let checked = event?.target?.checked;
    setCouponForm({ ...couponForm, [name]: value });
    if (name === 'excel') {
      setCouponForm({ ...couponForm, excel: checked ? true : false });
    }
    if (name === 'qrCodes') {
      setCouponForm({ ...couponForm, qrCodes: checked ? true : false });
    }
    if (name === 'pdfFiles') {
      setCouponForm({ ...couponForm, qrCodes: true, pdfFiles: checked ? true : false });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await post(couponForm, '/cs/coupons-trackers');
      toast.success('Coupon Generated successfully');
      setShowConfirmModel(false);
      getCoupons();
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
    }
  };

  function getCoupons() {
    try {
      get(`/cs/coupons-trackers/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`).then((response) => {
        setCouponList(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getCompanies() {
    try {
      get(`/cs/companies`).then((response) => {
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useEffect(() => {
    getCoupons();
  }, [currentPage]);

  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Coupons' },
          { link: '#', title: 'Coupons' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Coupons | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add New Coupons
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table className="text-center" responsive striped>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Company</th>
                    <th>Coupon Value</th>
                    <th>Total Coupons</th>
                    <th>Total Redeemed</th>
                    <th>Valid From</th>
                    <th>Valid Till</th>
                    <th>Without QR Code</th>
                    <th>With QR Code</th>
                    <th>View Coupons</th>
                  </tr>
                </thead>
                <tbody>
                  {couponList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item?.Company?.name}</td>
                        <td>{item?.couponValue}</td>
                        <td>{item?.totalCoupons}</td>
                        <td>{item?.totalRedeemedCoupon}</td>
                        <td>{item?.validFrom}</td>
                        <td>{item?.validTill}</td>
                        <td>
                          {item?.excelGenStatus ? (
                            <a
                              href={
                                item?.syncedExcelOnBucket
                                  ? `https://ks-erp.nyc3.digitaloceanspaces.com/uploads/cs/tracker_${item?.id}.xlsx`
                                  : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=uploads/cs/tracker_${item?.id}.xlsx`
                              }
                            >
                              <GrDocumentExcel
                                style={{ width: '25px', height: '20px' }}
                                className="react-icons green"
                                title="download excel"
                              />
                            </a>
                          ) : (
                            'Not Available'
                          )}
                        </td>
                        <td>
                          {item?.zipGenerationStatus === 1 ? (
                            'Zip Generation In Progress'
                          ) : item?.zipGenerationStatus === 2 ? (
                            <a
                              href={
                                item?.syncedZipOnBucket
                                  ? `https://ks-erp.nyc3.digitaloceanspaces.com/uploads/cs/tracker_${item?.id}.zip`
                                  : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=uploads/cs/tracker_${item?.id}.zip`
                              }
                            >
                              <GrDocumentZip style={{ width: '25px', height: '20px' }} className="react-icons red" title="download zip" />
                            </a>
                          ) : (
                            'Not Available'
                          )}
                        </td>
                        <td className="actions">
                          <Link to={`/cs/coupons/${item.id}`}>
                            <ViewIcon style={{ color: 'purple' }} />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Generate Coupons</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowConfirmModel(false)}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                  <Form.Select
                    className="input"
                    value={couponForm.companyId}
                    name="companyId"
                    onChange={handleChange}
                    placeholder="Company Id"
                    required
                  >
                    <option>Select Company</option>
                    {companyList.map((company) => (
                      <option key={company.id} id={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Coupon Value" className="mb-3">
                  <Form.Control
                    className="input"
                    name="couponValue"
                    value={couponForm.couponValue}
                    onChange={handleChange}
                    type="number"
                    placeholder="Coupon Value"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Total Coupons" className="mb-3">
                  <Form.Control
                    className="input"
                    name="totalCoupons"
                    value={couponForm.totalCoupons}
                    onChange={handleChange}
                    type="number"
                    placeholder="Total Coupons"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Valid From" className="mb-3">
                  <Form.Control
                    className="input"
                    name="validFrom"
                    value={couponForm.validFrom}
                    onChange={handleChange}
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Valid To" className="mb-3">
                  <Form.Control
                    className="input"
                    name="validTill"
                    value={couponForm.validTill}
                    onChange={handleChange}
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={12}>
                <div className="inline-radio">
                  <Form.Check
                    inline
                    label="Generate QR Codes"
                    name="qrCodes"
                    checked={couponForm.qrCodes === true}
                    onChange={handleChange}
                    type="switch"
                  />
                  <Form.Check
                    inline
                    label="Generate Excel"
                    name="excel"
                    checked={couponForm.excel === true}
                    onChange={handleChange}
                    type="switch"
                  />
                  <Form.Check
                    inline
                    label="Generate PDF"
                    name="pdfFiles"
                    checked={couponForm.pdfFiles === true}
                    onChange={handleChange}
                    type="switch"
                  />
                </div>
              </Col>
            </Row>
            <div className="container text-center">
              <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Coupons;
